import apiClient from './apiClient';

const baseUrl = process.env.REACT_APP_BASE_URL;

class AdminSubscriptionService {
  // Get subscription statistics
  async getSubscriptionStats() {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/subscriptions/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription stats:', error);
      throw error;
    }
  }

  // Get all subscriptions with pagination and filters
  async getAllSubscriptions(params = {}) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/subscriptions`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
      throw error;
    }
  }

  // Get subscription by ID
  async getSubscriptionById(subscriptionId) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/subscriptions/${subscriptionId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription by ID:', error);
      throw error;
    }
  }

  // Search subscriptions
  async searchSubscriptions(query, page = 0, size = 10) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/subscriptions`, {
        params: {
          search: query,
          page,
          size
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching subscriptions:', error);
      throw error;
    }
  }

  // Get all subscription plans
  async getAllPlans() {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/plans`);
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription plans:', error);
      throw error;
    }
  }
}

export default new AdminSubscriptionService();
